import React, { FC, useContext, useMemo } from 'react';

import { PlatformType } from '../../formulaEditor/assistant/components/notificationButton/constants';
import { filterButtonsByPlatform } from '../../formulaEditor/assistant/components/notificationButton/helpers';

// context
import { EditorContext } from '../../../../context/EditorContext';

import useQueryFormulaButtons from '../../../../hooks/formula-buttons/useQueryFetchFormulaButtons';

// models
import { MobilePushPreviewModel } from '../../../../models/editor.model';
import { PreviewComponentProps } from '../../../../models/formula.model';

// components
import Phone from '../shared/Phone';
// components
import MobilePushMessagePreview from './MobilePushMessagePreview';

const MobilePushMain: FC<
    React.PropsWithChildren<PreviewComponentProps<MobilePushPreviewModel>>
> = ({ randomSample, formulaHasVariant }) => {
    const { editorDetails } = useContext(EditorContext);

    const hasText = useMemo(() => {
        const previews =
            (editorDetails.previews?.[0] as any) ??
            (editorDetails.testPreviews?.[0] as any);
        return previews?.content.header || previews?.content.body;
    }, [editorDetails.previews, editorDetails.testPreviews]);

    const formulaButtons = useQueryFormulaButtons(editorDetails.formula?.id);

    const androidPlatformButtons = filterButtonsByPlatform(
        formulaButtons.data,
        PlatformType.ANDROID,
    );
    const iosPlatformButtons = filterButtonsByPlatform(
        formulaButtons.data,
        PlatformType.IOS,
    );

    return (
        <Phone hasText={hasText} formulaHasVariant={formulaHasVariant}>
            {randomSample.map((msg, i) => (
                <MobilePushMessagePreview
                    key={i + msg.id}
                    formula_id={msg.formula_id}
                    id={msg.id}
                    content={{
                        header: msg.content.header,
                        body: msg.content.body,
                    }}
                    phonePreview={true}
                    image_url={msg.image_url}
                    buttons={
                        editorDetails.isSecondaryView
                            ? androidPlatformButtons
                            : iosPlatformButtons
                    }
                    isSecondaryView={editorDetails.isSecondaryView}
                />
            ))}
        </Phone>
    );
};

export default MobilePushMain;
